export enum FileType {
  Image = "image/*",
  Audio =  "audio/*",
  Vieo = "video/*" ,
  Document = "application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
}

export enum Roles {
  SUPERADMIN = "SUPERADMIN"
}

/**
 * Jenis object yg dapat memiliki RBD
 */
export enum RBDType {
  STATION = "STATION",
  SYSTEM = "SYSTEM"
}

/**
 * Jenis item di dalam setiap row pada RBD
 */
export enum RBDItemType {
  ELEMENT = "ELEMENT",
  TRANSMISSION = "TRANSMISSION"
}

/**
 * Jenis elemen pada item row RBD
 */
export enum RBDElementType {
  SYSTEM = "SYSTEM",
  EQUIPMENT = "EQUIPMENT"
}

/**
 * Jenis transmission pada item row RBD
 */
export enum RBDTransmissionType {
  SERIAL = "SERIAL",
  PARALLEL = "PARALLEL",
  REDUNDANT = "REDUNDANT",
  SHARING_LOAD = "SHARING_LOAD"
}

export const enumDescription = <T>(value: T) => {
  switch (value)
  {
    default: return toTitleCase(value);
  }
}

const toTitleCase = (str: any) => {
  let words: string[] = str.toString().toUpperCase().split('_');
  return words.map(word => {
    return word.charAt(0) + word.substring(1).toLowerCase();
  }).join(' ');
}

//Notes: yang dikirim di db keys nya

export function enumToArray(obj: any) {
  return Object.keys(obj).map((value) => ({ value , text: obj[value] }));
}  

export const enumMap = <T>(obj: {[key: string]: string}, callbackFn: (value: string, description: string, index: number) => T): T[] => {
  // const enumValues: string[] = Object.values(obj);
  return Object.keys(obj).map<T>(
      (k, i) => callbackFn(k, enumDescription(obj[k]), i)
  )
}

export enum EquipmentColors {
  Green = '#66BB6A',
  Yellow = '#FFE437',
  Orange = '#FF9900',
  Red = '#F44335',
}